import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetGrammarWorkoutV1Response } from './get-grammar-workout-v1-response';
import { getGrammarWorkoutV1ResponseSchema } from './get-grammar-workout-v1-response';

export async function getGrammarWorkoutV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetGrammarWorkoutV1Response>> {
  return getRequest<IGetGrammarWorkoutV1Response>({
    path: '/grammar/workout/v1',
    schema: getGrammarWorkoutV1ResponseSchema,
    options,
  });
}
